import orderTemplate from "./orderTemplate"
import { generateSetChild, generateAddArrayChild, generateUpdateArrayChild, generateRemoveArrayChild, generateSetMapChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import { dayjs, dayjsServer } from '@/helpers/dayjs'
import { fwgpricecent } from '@/helpers/FilterFwg'
import { format } from '@/utils/format'

let template = orderTemplate({ config })

export default {
	namespaced: true,
	state: {
		...template.state,
		location: null,
		liveOrderStates: []
	},
	actions: {
		...template.actions,
		getAdtTracking({state, getters}) {
			return {
				currency: getters.payments[0]?.price?.currency || '',
				total: fwgpricecent(state.serverData?.totals?.totalNet || 0, 'short'),
				emailHash: state.serverData?.emailHash || '',
				number: state.serverData?.number || 0,
				coupon: getters.discounts[0]?.code || '',
			}
		},
		getGtmTracking({state, getters}) {
			return {
				id: state.serverData?.number || 0,
				channelName: getters.channelName,
				revenue: fwgpricecent(getters.total || 0, 'short'),
				tax: fwgpricecent(state.serverData?.totals?.taxes || 0, 'short'),
				shipping: getters.deliveryPrice || 0,
				shippingMethod: getters.shippingMethod?.name || '',
				coupon: getters.discounts?.map(d => d.name).join(', ') || '',
				couponvalue: fwgpricecent(getters.discounts.reduce((v, d) => v + Math.abs(d.amount.current), 0) || 0, 'short'),
				brand: config.BRAND,
				zip: state.serverData?.shippingAddress?.postcode || '',
				products: getters.items.map(p => ({
					id: p.variantCode || p.code,
					name: p.displayName,
					category: 'default',
					price: fwgpricecent(p.originalTotal || 0, 'short'),
					quantity: p.quantity,
				})),
				orderType: getters.orderType,
        emailHash: state.serverData.emailHash256
			}
		},
		async createTipOrder({state, dispatch}, { tip } = {}) {
			await dispatch('loader/setLoading', true, { root: true })
			const order = await service.createTipOrder({ tip, tipOption: state.tipOption, tipMainVariant: state.tipMainVariant, tipSubVariant: state.tipSubVariant, token: state.basketToken});
			await dispatch('loader/setLoading', false, { root: true })

			if (order.payments.length > 0) {
				const payment = order.payments.find(payment => payment.state === 'new')

				if (payment.method.code === 'wallee' || payment.method.walleePaymentMethodConfigurationId) {
					await dispatch('payWithWallee', {
						order,
						payment,
						redirects: {
							checkoutComplete: format(config.ORDER_FEEDBACK_COMPLETE_TYPE_URL, {basketToken: order.tokenValue}),
							checkoutSuccess: format(config.ORDER_FEEDBACK_SUCCESS_URL, {basketToken: order.tokenValue}),
							checkoutCancel: format(config.ORDER_FEEDBACK_CANCEL_URL, {basketToken: state.basketToken}),
							checkoutError: format(config.ORDER_FEEDBACK_ERROR_URL, {basketToken: state.basketToken}),
						}
					}, { root: true })
				} else if (payment.method.code === 'datatrans' || payment.method.datatransPaymentMethod) {
					try {
						await dispatch('payWithDatatrans', {
							order,
							email: '',
							redirects: {
								checkoutComplete: format(config.ORDER_FEEDBACK_COMPLETE_TYPE_URL, {basketToken: order.tokenValue}),
								checkoutSuccess: format(config.ORDER_FEEDBACK_SUCCESS_URL, {basketToken: order.tokenValue}),
								checkoutCancel: format(config.ORDER_FEEDBACK_CANCEL_URL, {basketToken: state.basketToken}),
								checkoutError: format(config.ORDER_FEEDBACK_ERROR_URL, {basketToken: state.basketToken}),
							}
						}, { root: true })
					} catch(err) {
						config.DEBUG && console.error(err);
						if (err == "closed") {
							dispatch('redirect', {
								name: "order-feedback-cancel",
								params: {basketToken: state.basketToken}
							}, { root: true })
						}
					}
				}
			}
		},
		async loadOrderLocation({ commit, getters }) {
			if (getters.shopLocation) {
				const result = await service.location({ channel: getters.shopLocation})

				if (result.locations?.length) {
					const [location] = result.locations;
					commit('setLocation', { item: location });
				}
			}
		},
		async getLiveOrderState({ commit, rootGetters }, { tokenValues, accumulatorGroup = null } = {}) {
			let result = []
			if (!tokenValues?.length) {
				if (rootGetters['account/isLoggedIn']) {
					result = await service.liveOrderStateUser({ brand: config.BRAND, accumulatorGroup })
				}
			}
			else {
				if (!Array.isArray(tokenValues)) {
					tokenValues = [tokenValues]
				}

				result = await service.liveOrderState({ tokenValues, brand: config.BRAND, accumulatorGroup })
			}

			commit('setLiveOrderStates', { item: result })
			return result
		}
	},
	getters: {
		...template.getters,
		cartDeliveryTime(state) {
			return state.serverData
				? dayjsServer(state.serverData.deliveryTime)
				: null
		},
		billingAddress(state) {
			return state.serverData?.billingAddress || {}
		},
		shippingAddress(state) {
			return state.serverData?.shippingAddress || {}
		},
		dropoffType(state) {
			return state.serverData?.dropoffType || 0
		},
		notes(state) {
			return state.serverData?.notes || ''
		},
		useDishes(state) {
			return state.serverData?.useDishes || false
		},
		orderLocation(state) {
			return state.location || null
		},
		orderSurveyUrl(state) {
			return state.serverData?.surveyUrl || ''
		},
		orderNpsSurveyUrl(state, getters) {
			return config.NPS_SURVEY_URL ? format(config.NPS_SURVEY_URL, { channelCode: getters.shopLocation}) : ''
		},
		orderTipSurveyUrl(state) {
      const { tokenValue, tipMainVariant, tipSubVariant } = state.serverData
			return config.TIP_SURVEY_URL ? format(config.TIP_SURVEY_URL, { tokenValue, tipMainVariant, tipSubVariant }) : ''
		},
		liveOrderStates(state) {
			return state.liveOrderStates
        .filter(order => order.state && config.LIVE_ORDER_STATES.includes(order.state))
        .map(order => ({
          ...order,
          url: `${config.SHOPMANAGER_ENDPOINT}/order-confirmation/${order.tokenValue}`
        }));
		}
	},
	mutations: {
		...template.mutations,
		setLocation: generateSetChild('location'),
		setLiveOrderStates: generateSetChild('liveOrderStates'),
	},
}
